export function lowerDividend(value: number, divider: number): number {
  return Math.floor(value / divider) * divider;
}

export function nearestDividend(value: number, divider: number): number {
  return Math.round(value / divider) * divider;
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/math.helpers.ts